import Image from "next/image";
import { cn } from "@/lib/utils";
import { countryName, flagSrc, isCountryCode } from "../lib/countries";

/**
 * `EX-IDN03` (ADR-0088 decision 7): a country's flag, an image from
 * `public/flags` and never an emoji (Windows prints a flag emoji as its two
 * letters). The country's name, in the reader's language, is its alt text and
 * its tooltip. Nothing renders for a missing or unknown code.
 */
export function CountryFlag({
  code,
  locale,
  className,
  decorative = false,
}: {
  code: string | null | undefined;
  locale: string;
  className?: string;
  /** When the country's name is printed beside it, the flag says nothing more. */
  decorative?: boolean;
}) {
  if (!isCountryCode(code)) return null;
  const name = countryName(code, locale);
  return (
    <Image
      src={flagSrc(code)}
      alt={decorative ? "" : name}
      title={name}
      width={20}
      height={15}
      unoptimized
      className={cn("inline-block h-[15px] w-5 shrink-0 rounded-[2px] object-cover ring-1 ring-black/10", className)}
    />
  );
}
